export const CREATE_CONTRACT = 'CREATE_CONTRACT'
export const UPDATE_CONTRACT = 'UPDATE_CONTRACT'
export const DELETE_CONTRACT = 'DELETE_CONTRACT'
export const TOGGLE_MODAL = "TOGGLE_MODAL"
export const TOGGLE_EDIT_MODAL = "TOGGLE_EDIT_MODAL"
export const EDIT_MODAL_DATA = "EDIT_MODAL_DATA"
export const SET_DATA_CONTRACT = "SET_DATA_CONTRACT"
export const CREATE_NEW_CONTRACT = "CREATE_NEW_CONTRACT"
export const UPDATE_DATA_PRICE = "UPDATE_DATA_PRICE"

